export default __webpack_public_path__ + "static/media/placeholder_portfolio03-nl-web.67edd6f6.png";